// FloatingChatBubble.jsx
/**
 * FloatingChatBubble
 * - Shows a chat icon until HubSpot chat is loaded
 */
export default function FloatingChatBubble({ openChat, isLoading =false }) {
 
  return (
    <button
      onClick={openChat}
      aria-label="Open live chat"
      title="Open live chat"
      aria-busy={isLoading}
      aria-disabled={isLoading}
      disabled={isLoading}
      style={{
        // HubSpot-like bubble: 60x60, brand color, shadow
        position: "fixed",
        right: 16,
        bottom: 16,
        width: 60,
        height: 60,
        borderRadius: "50%",
        border: "none",
        backgroundColor: "#425B76", // rgb(66, 91, 118)
        color: "#fff",
        boxShadow: "0 12px 28px rgba(0,0,0,0.24)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        zIndex: 2147483000
      }}
    >
     {isLoading ? (
        // Minimal inline SVG spinner (no external CSS)
        <svg
          width="26"
          height="26"
          viewBox="0 0 50 50"
          role="img"
          aria-label="Loading"
        >
          {/* background track */}
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke="#ffffff"
            strokeOpacity="0.25"
            strokeWidth="6"
          />
          {/* animated arc */}
          <path
            d="M45 25a20 20 0 0 1-20 20"
            fill="none"
            stroke="#ffffff"
            strokeWidth="6"
            strokeLinecap="round"
            transform="rotate(0 25 25)"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 25 25"
              to="360 25 25"
              dur="0.8s"
              repeatCount="indefinite"
            />
          </path>
        </svg>
      ) : (
        // HubSpot messages icon (closed state), sized 32x30
        <svg
        width="32"
        height="30"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="#ffffff"
        aria-hidden="true"
      >
        {/* exact shape of the messages icon; no "X" variant */}
        <g clipPath="url(#messages__clip0)">
          <path fillOpacity="0.01" d="M0 0h24v24H0z"></path>
          <mask id="messages__b" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24" style={{ maskType: "alpha" }}>
            <g clipPath="url(#messages__clip1)">
              <g clipPath="url(#messages__clip2)">
                <mask id="messages__a" maskUnits="userSpaceOnUse" x="1" y="0" width="23" height="23" style={{ maskType: "alpha" }}>
                  <path d="M2.571 22.286h-.008.008z"></path>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.143 4.286c1.414 0 2.571 1.157 2.571 2.571v8.572c0 1.414-1.157 2.571-2.571 2.571H7.209l-4.037 4.037c-.162.162-.384.247-.606.248-.11 0-.219-.017-.32-.068-.317-.128-.532-.445-.532-.788V6.857c0-1.414 1.157-2.571 2.572-2.571h12.857zM4.286 6c-.472 0-.857.386-.857.857v12.506l2.82-2.82c.162-.163.377-.249.608-.249h10.286c.471 0 .857-.385.857-.857V6.866c0-.472-.386-.857-.857-.857H4.286V6z"
                  ></path>
                  <path d="M20.571.857c1.415 0 2.572 1.158 2.572 2.572V12c0 .472-.386.857-.857.857-.472 0-.857-.385-.857-.857V3.43c0-.472-.386-.857-.858-.857H7.714c-.471 0-.857-.386-.857-.857 0-.472.386-.858.857-.858h12.857z"></path>
                </mask>
                <g mask="url(#messages__a)">
                  <path d="M-1.714-1.714h27.429v27.429H-1.714z"></path>
                </g>
              </g>
            </g>
          </mask>
          <g mask="url(#messages__b)">
            <path d="M0 0h24v24H0V0z"></path>
          </g>
        </g>
        <defs>
          <clipPath id="messages__clip0"><path d="M0 0h24v24H0z"></path></clipPath>
          <clipPath id="messages__clip1"><path d="M0 0h24v24H0z"></path></clipPath>
          <clipPath id="messages__clip2"><path transform="translate(-1.714 -1.714)" d="M0 0h27.429v27.429H0z"></path></clipPath>
        </defs>
      </svg>
        )}
   </button>
  );
}
